import { appConfig } from '../configureApp';
const isTugoEnv = appConfig.reactAppEnv === 'tugo';

const routeConfig = {
  login: '/',
  claimList: '/claim-list',
  claimWizard: '/wizard',
  postSubmit: '/post-submit',
  postSubmitSCTI: isTugoEnv
    ? '/post-submit-tugo'
    : '/post-submit-scti',
};

export default routeConfig;



// WEBPACK FOOTER //
// ./app/utils/routeConfig.js